import {
  DIMENSION_UNIT_LABEL,
  DimensionUnitSchema,
  type DimensionUnit,
} from "@forgepoint/shared";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { ITEM_OVERRIDE_FIELD_LABELS } from "@/modules/quotes/itemOverrideFieldLabels";

interface LineDimensionUnitSelectProps {
  id: string;
  value: DimensionUnit | null | undefined;
  itemDimensionUnit: DimensionUnit;
  onChange: (next: DimensionUnit | null) => void;
}

/**
 * Picker for the unit a quote line's sizes are in. Picking the item's own
 * dimension unit clears the override.
 */
export function LineDimensionUnitSelect({
  id,
  value,
  itemDimensionUnit,
  onChange,
}: LineDimensionUnitSelectProps) {
  const handleValueChange = (next: string) => {
    const parsed = DimensionUnitSchema.safeParse(next);
    if (!parsed.success) {
      return;
    }
    onChange(parsed.data === itemDimensionUnit ? null : parsed.data);
  };

  return (
    <div className="mb-2 flex items-center gap-2">
      <Label htmlFor={id} className="text-xs font-normal text-muted-foreground">
        {ITEM_OVERRIDE_FIELD_LABELS.dimensionUnit}
      </Label>
      <Select
        value={value ?? itemDimensionUnit}
        onValueChange={handleValueChange}
      >
        <SelectTrigger id={id} size="sm" className="w-40 text-xs sm:text-sm">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {DimensionUnitSchema.options.map((unit) => (
            <SelectItem key={unit} value={unit}>
              {DIMENSION_UNIT_LABEL[unit]}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
